import { AIBadge } from '@/components/ui/ai-badge';
import { SECTIONS } from '@/components/wizard/constants';

import type { ReportData, Section } from '../types';

interface StandaloneSectionTitleProps {
    section: Section;
    data: ReportData;
}

export default function StandaloneSectionTitle({ section, data }: StandaloneSectionTitleProps) {
    const primaryColor = data?.customizations?.colors?.primary;

    const hasAutoTests =
        section.id === SECTIONS.TESTS &&
        (data.tests?.blocks || []).some(
            (block) => 'automatic' in block && Boolean(block.automatic),
        );

    return (
        <>
            <div className="relative mb-2 flex items-center justify-between gap-3">
                <h2 className="flex flex-grow items-center gap-2 text-lg font-bold text-slate-700">
                    <span style={{ color: primaryColor }}>{section.number}.</span>
                    <span>{section.title}</span>
                </h2>

                {hasAutoTests && <AIBadge>Gerado automaticamente</AIBadge>}
            </div>
            <hr style={{ borderColor: primaryColor }} className="my-1 mb-2 border-t" />
        </>
    );
}
